import { ROUTE_MODULE_MAP } from '@/shared/lib/permissions';

const SHORT_KEY_TO_ROUTE: Record<string, string> = {
  kpi_dashboard: '/',
  employees: '/employees',
  medical_checks: '/medical',
  training: '/training',
  sout_opr: '/sout',
  risks: '/risks',
  ppe: '/siz',
  documents: '/documents',
  reports: '/reports',
  administration: '/admin',
};

/** Ключ из GET /home/sections → путь пункта бокового меню (key у Menu). */
export function menuRouteFromHomeSectionKey(sectionKey: string): string | undefined {
  const trimmed = sectionKey.trim();
  if (!trimmed) return undefined;

  if (trimmed.startsWith('/')) {
    if (trimmed === '/' || ROUTE_MODULE_MAP[trimmed] !== undefined) {
      return trimmed;
    }
    return undefined;
  }

  const mapped = SHORT_KEY_TO_ROUTE[trimmed];
  if (mapped) return mapped;

  const asRoute = `/${trimmed}`;
  if (ROUTE_MODULE_MAP[asRoute] !== undefined) {
    return asRoute;
  }
  return undefined;
}
